<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ label }}</span>
    <PrimeInputNumber
      v-model="value"
      required="required"
      @input="oninput"
      :min="min"
      :max="max"
    />
  </div>
</template>


<script>
export default {
  props: ["modelValue", "label", "required","min","max"],
  emits: ["update:modelValue"],

  data() {
    return {
      value: null,
    };
  },
  created() {
    this.value = this.modelValue;
  },
  methods: {
    oninput(event) {
     this.$emit("update:modelValue", event.value);
    },
  },
};
</script>
